// Functional component for the badges showcasing restaurants in the navbar

import LengthBadge from "./LengthBadge";
import { useContext } from "react";
import { ThemeContext } from "../App";
import { Restaurant } from "../models/RestaurantInfo";

interface RestaurantBadgeProps {
    restaurant: Restaurant;
    isSelected: boolean;
    clickHandler(id: number): void;
}

const RestaurantBadge = (props: RestaurantBadgeProps) => {
    const { theme } = useContext(ThemeContext);
    // Selected badge is highlighted
    const classNameAppendage = props.isSelected ? "restaurantbadge--selected" : "";

    return (
        <div
            className={`restaurantbadge + ${classNameAppendage}`}
            id={theme}
            onClick={(event) => {
                if (props.isSelected) {
                    // Clicking the selected badge will deselect
                    props.clickHandler(-1);
                } else {
                    props.clickHandler(props.restaurant.restaurantID);
                }
            }}
        >
            {/* Long restaurant names are given a smaller font and their names shortened in order to fit in the navbar */}
            <h3 className={props.restaurant.restaurantName.length <= 12 ? "" : "restaurantbadge--smallfont"}>
                {props.restaurant.restaurantName.length <= 12 ? props.restaurant.restaurantName : props.restaurant.restaurantName.slice(0, 12) + "..."}
            </h3>
            <LengthBadge queueLabel={props.restaurant.queueLabel}/>
        </div>
    );
};

export default RestaurantBadge;
